import * as React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

const Homepage = Scrivito.connect((props) => (
  <ObjValidator {...props}>{<div data-testid="homepage" />}</ObjValidator>
));

export default Homepage;
Scrivito.provideComponent("Homepage", Homepage);
